var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"e-close-badge"},_vm.$listeners),[_c('span',{staticClass:"icon-close-sign"})])
}
var staticRenderFns = []

export { render, staticRenderFns }